import { createHttpService } from "../ApiService";
import { mergePageSizePaginationQuery } from "../common.interfaces";
import {
  TAuditTrailResponse,
  TAuditTrailFilter,
} from "./auditTrail.interfaces";
import { auditTrailResponseMock } from "../../__mocks__/auditTrail/auditTrailMock";

export const useAuditTrailService = () => {
  const httpAPI = createHttpService();
  const baseAuditTrailPath = "";

  // All APIs use mocks by default
  const shouldUseMock = true;

  const getAuditTrail = (filters?: TAuditTrailFilter) => {
    if (shouldUseMock) {
      return Promise.resolve(auditTrailResponseMock);
    }
    const pagination = mergePageSizePaginationQuery(
      filters !== undefined
        ? { page: filters.page, pageSize: filters.pageSize }
        : undefined,
    );
    const params =
      filters !== undefined ? { ...filters, ...pagination } : pagination;
    return httpAPI.auditTrail.get<TAuditTrailResponse>(
      `${baseAuditTrailPath}`,
      {
        params,
      },
    );
  };

  const exportAuditTrail = (filters?: TAuditTrailFilter) => {
    if (shouldUseMock) {
      return Promise.resolve(new Blob());
    }
    const pagination = mergePageSizePaginationQuery(
      filters !== undefined
        ? { page: filters.page, pageSize: filters.pageSize }
        : undefined,
    );
    const params =
      filters !== undefined ? { ...filters, ...pagination } : pagination;
    return httpAPI.auditTrail.get<Blob>(`${baseAuditTrailPath}/export`, {
      params,
      responseType: "blob",
    });
  };

  return {
    getAuditTrail,
    exportAuditTrail,
  };
};
